module.exports = __webpack_public_path__ + "media/styles/images/png/ex-red-962c322894b66da3c9b1d31cf1a86b32.png";